import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

function SelectCountries(props) {
  const { theme } = useTheme();
  const title = props.title.replaceAll(" ", "-").toLowerCase();

  return (
    <FormControl
      size={props.size}
      sx={{ mr: 1, fontFamily: theme.fontFamily }}
      variant="outlined"
      fullWidth={props.width ? true : false}
      error={props.required && (!props.value || props.value === "")}
    >
      <InputLabel
        id={`select-label-${title}`}
        sx={{
          fontFamily: theme.fontFamily,
          color: theme.text.primary,
          '&.Mui-focused': {
            color: theme.color.primary, // Change label color on focus
          },
        }}
      >
        {props.title}
      </InputLabel>
      <Select
        labelId={`select-label-${title}`}
        id={`select-${title}`}
        value={props.value}
        label={props.title}
        onChange={(e) => props.onChange(e.target.value)}
        sx={{
          color: theme.text.primary,
          fontFamily: theme.fontFamily,
          '& .MuiSelect-icon': {
            color: theme.text.primary, // Set chevron icon color
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.text.primary, // Set border color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.text.primary, // Set border color on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.color.primary, // Set border color when focused
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 400, // Adjust this as necessary
            },
          },
          anchorOrigin: {
            vertical: 'bottom', // Ensures the dropdown opens below
            horizontal: 'left', // Aligns with the left edge
          },
          transformOrigin: {
            vertical: 'top', // Ensures the dropdown opens above the anchor
            horizontal: 'left',
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem
            key={`${option.value} - ${option.name}`}
            value={`${option.value} - ${option.name}`}
            sx={{ fontFamily: theme.fontFamily, display: 'flex', alignItems: 'center' }}
          >
            {/* Flag Image */}
            <img
              src={`https://flagcdn.com/w20/${option.value.toLowerCase()}.png`} // assuming flag URL format
              alt={""}
              style={{ width: 20, height: 15, marginRight: 10 }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg";
              }}
            />
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectCountries;
